import { css } from '@emotion/react';

export const container = (isRoot) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    background-color: ${isRoot ? '#002755' : '#ffffff'};
    box-shadow: ${isRoot ? 'none' : '0 2px 8px rgba(0, 0, 0, 0.1)'};
`;

export const containerInner = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 1370px;
`;

export const logo = css`
    display: flex;
    height: 25px;
`;

export const line = css`
    width: 2px;
    background-color: lightgray;
    margin: 0 15px;
`;

export const copyright = (isRoot) => css`
    color: ${isRoot ? '#fdfdfd' : 'black'};
    text-align: end;
    font-size: 10px;
    line-height: 1.5;
`;
